"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      shape = _ref.shape;
  return {
    modal: {
      overflow: 'auto',
      padding: '120px 0 120px 0',
      display: 'flex'
    },
    cancelButton: {
      backgroundColor: 'transparent',
      color: palette.grey.main,
      border: "1px solid ".concat(palette.divider),
      boxShadow: 'none',
      marginRight: spacing(1),
      height: 48,
      padding: spacing(1, 4)
    },
    submitButton: {
      backgroundColor: palette.error.main,
      color: 'white',
      boxShadow: 'none',
      height: 48,
      padding: spacing(1, 4)
    },
    avatar: {
      backgroundColor: palette.error.main,
      width: 46,
      height: 46,
      marginRight: spacing(2)
    },
    paper: {
      position: 'relative',
      maxWidth: 805,
      margin: 'auto',
      minWidth: 580,
      minHeight: 400,
      borderRadius: shape.borderRadius,
      backgroundColor: palette.common.white,
      padding: spacing(2, 3, 3),
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      outline: 'none'
    }
  };
});

var VidyardIntegrationModal = function VidyardIntegrationModal(_ref2) {
  var handleSelect = _ref2.handleSelect,
      open = _ref2.open,
      onClose = _ref2.onClose,
      _ref2$vidyardClientId = _ref2.vidyardClientId,
      vidyardClientId = _ref2$vidyardClientId === void 0 ? '' : _ref2$vidyardClientId;
  var classes = useStyles();
  var vidyardContainer = (0, _react.useRef)(null);
  var _window = window,
      Vidyard = _window.Vidyard;
  var renderVidyard = (0, _react.useCallback)(function () {
    if (vidyardClientId && Vidyard) {
      var library = Vidyard.goVideo.createLibrary(vidyardContainer.current, {
        clientId: vidyardClientId
      });
      library.on('player:created', function (response) {
        handleSelect(response.embed_codes);
      });
    }
  }, [handleSelect, vidyardClientId, Vidyard]);
  var modalRef = (0, _react.useCallback)(function (node) {
    if (node !== null) {
      renderVidyard();
    }
  }, [renderVidyard]);
  return /*#__PURE__*/_react["default"].createElement(_material.Modal, {
    ref: modalRef,
    open: open,
    onClose: onClose,
    className: classes.modal
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.paper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: vidyardContainer
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(VidyardIntegrationModal);

exports["default"] = _default;